import { render, staticRenderFns } from "./BooksAssignedToMe.vue?vue&type=template&id=a521695a"
import script from "./BooksAssignedToMe.vue?vue&type=script&lang=js"
export * from "./BooksAssignedToMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports